<template>
  <div class="hello">
    <h1>{{ msg }}</h1>

    <button v-if="user" @click="logout">Logout</button>
    <!-- <button v-if="!user" @click="login">Login</button> -->
    <button v-if="!user" @click="loginGoogle">Login Google</button>

    <router-link v-if="user" to="/examples">Examples</router-link>
    <router-link v-if="user" to="/firepad">Firepad</router-link>

    <router-link v-if="user" to="/aviasim">AviaSim</router-link>
    <router-link v-if="user" to="/building">Building</router-link>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'hello',
  methods: {
    ...mapActions(['login', 'loginGoogle', 'logout'])
  },
  computed: {
    ...mapState(['user'])
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?5943fdeb